export default __webpack_public_path__ + "static/media/dark1.067db6d8.jpg";